<template>
  <div style="color: #0070b0; font-weight: bold; font-family: system-ui; direction: rtl;" class="p-0">

    <!-- BOTTOM BAR -->
    <div class="row m-0 fixed-bottom time rtl bottomBar">
      <div class="col-4 text-center errorsTimeMap" ref="pointsCounting">
        <div style="color: yellow; padding-top: 10px">
          <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor" class="bi bi-star-fill"
            viewBox="0 0 16 16">
            <path
              d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
          </svg>
        </div>
        <div style="direction: ltr">{{ errorNumber }}</div>
        <div v-if="showStar" class="position-relative starMoveUp">
          <svg style="color: yellow; position: relative; left: -13px" xmlns="http://www.w3.org/2000/svg" width="50"
            height="50" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
            <path
              d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
          </svg>
          <span class="position-relative" style="left: 23px; top: 4px; color: black">{{ numberOfPoints }}</span>
        </div>
      </div>

      <div class="col-4 text-center errorsTimeMap" @click="requestBuzzer" ref="tutPointNum">
        <div class="evolutionBottomDiv">
          <!-- Countdown timer when on navigation screen -->
          <span v-if="countdownTimer && showMainScreen" class="countdown-in-circle">{{ countdownTimer }}</span>
          <!-- Smiley inside circle when active -->
          <img v-else-if="currentSmiley"
            class="smiley-circle-img"
            :style="getSmileyStyle(currentSmiley)"
            :src="require(`../../static/img/${currentSmiley}.png`)" alt="" />
          <!-- Default: point number -->
          <span v-else class="point-num-text">{{ pointNumForEvolution }}</span>
        </div>
        <div style="position: relative; bottom: 32px">
          {{ pointNumForEvolution }}/{{ Object.values(pointsArrayOrder).length }}
        </div>
      </div>

      <div class="col-4 text-center errorsTimeMap pt-4" @click="slideMapInn" ref="tutMapBtn">
        <svg class="bi bi-map" width="20px" height="20px" viewBox="0 0 16 16" fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
            d="M15.817.613A.5.5 0 0116 1v13a.5.5 0 01-.402.49l-5 1a.502.502 0 01-.196 0L5.5 14.51l-4.902.98A.5.5 0 010 15V2a.5.5 0 01.402-.49l5-1a.5.5 0 01.196 0l4.902.98 4.902-.98a.5.5 0 01.415.103zM10 2.41l-4-.8v11.98l4 .8V2.41zm1 11.98l4-.8V1.61l-4 .8v11.98zm-6-.8V1.61l-4 .8v11.98l4-.8z"
            clip-rule="evenodd" />
        </svg>
        <span id="carte">{{ translation.map }}</span>
      </div>
    </div>
    <!-- END BOTTOM BAR -->

    <!-- PHASE 1: MAIN NAVIGATION SCREEN -->
    <div v-if="showMainScreen" style="width: 100%; min-height: calc(100vh - 150px); margin-bottom: 55px;">

      <!-- GPS permission prompt — shown only for dynamicMap points before permission is resolved -->
      <div v-if="gpsPromptVisible" class="gps-prompt-overlay">
        <div class="gps-prompt-card">
          <div class="gps-prompt-icon">📍</div>
          <h3 class="gps-prompt-title">Localisation GPS</h3>
          <p class="gps-prompt-text">
            Ce point utilise une carte interactive.<br>
            Pour voir votre position, autorisez l'accès à votre géolocalisation.
          </p>
          <p class="gps-prompt-sub">
            Un message de confirmation peut apparaître. Si vous avez déjà refusé,
            activez la localisation dans les réglages de votre navigateur.
          </p>
          <div v-if="gpsStatus === 'checking'" class="gps-checking">⏳ Vérification…</div>
          <template v-else>
            <button class="gps-prompt-btn-primary" @click="requestGpsPermission">
              📍 Autoriser ma position
            </button>
            <button class="gps-prompt-btn-secondary" @click="skipGpsPermission">
              Continuer sans GPS
            </button>
          </template>
        </div>
      </div>

      <!-- Brief banner when GPS was denied and we fell back to imagesList -->
      <transition name="fade">
        <div v-if="gpsDeniedBannerVisible" class="gps-denied-banner">
          📍 GPS non disponible — navigation par images activée
        </div>
      </transition>

      <component v-if="isReady && !gpsPromptVisible" :is="navigationScreen" :key="pointNum" ref="navScreen" />
    </div>

    <div v-if="showMissingWord" style="width: 100%;">
      <MissingWord :pointData="currentPoint" />
    </div>

    <!-- PHASE 3: EXERCISE SCREEN -->
    <div v-if="showPickedItem"
      style="position: fixed; top: 70px; left: 0; width: 100vw; height: 80vh; z-index: 2; display: flex; flex-direction: column; align-items: center; overflow-y: auto;">
      <div style="width: 100%; max-width: 600px; padding: 20px;">
        <Puzzle v-if="showPuzzle" :pointData="currentPoint" @puzzle-done="onPuzzleDone" @star-up="onPuzzleStarUp" />
        <Question v-if="showQuestions" :pointData="currentPoint" />
        <MultipleMatch v-if="showMultipleMatch" :pointData="currentPoint" />
        <PhotoComponent v-if="showPhotoComponent" :pointData="currentPoint" />
        <Memory v-if="showMemory" :customImages="currentPoint && currentPoint.memoryImages || []" @memory-done="onMemoryDone" @star-up="onMemoryStarUp" />
        <JusteFaux v-if="showJusteFaux" :pointData="currentPoint" @jf-done="onJusteFauxDone" />
        <MotManquant v-if="showMotManquant" :pointData="currentPoint" @mm-done="onMotManquantDone" />
        <RushHour v-if="showRushHour" :pointData="currentPoint" @rh-done="onRushHourDone" />
        <SignCard v-if="showSignCard" :pointData="currentPoint" @sc-done="onSignCardDone" />
      </div>
    </div>

    <!-- PHASE 2: INFORMATION SCREEN -->
    <div v-if="showPointInformation" :class="['info-screen', { 'info-screen--fullvideo': currentInfoSource && currentInfoSource.withVerticalVideo }]">

      <!-- AR mode: camera + GIF inside the info screen -->
      <template v-if="currentInfoSource && currentInfoSource.withAR">
        <ArComponent
          :pointData="currentInfoSource"
          :audioUrl="audioUrl"
          :lang="$store.getters.lang"
        />
        <div class="ar-top-btn-bar">
          <button class="ar-top-btn ar-top-btn--continue" @click="afterInfoComplete">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
            <span class="ar-top-btn-label">{{ translation.goToQuestions }}</span>
          </button>
        </div>
      </template>

      <!-- Non-AR layouts -->
      <template v-if="!(currentInfoSource && currentInfoSource.withAR)">

      <!-- LAYOUT PHONE: incoming call screen -->
      <template v-if="currentInfoSource && currentInfoSource.withPhone">
        <div class="phone-screen">
          <!-- Ring sound loops until answered -->
          <!-- Ring played programmatically in showPhoneScreen watcher for reliable autoplay -->
          <audio ref="phoneRing" style="display:none"></audio>

          <!-- INCOMING CALL -->
          <div v-if="!phoneCallAnswered" class="phone-incoming">
            <div class="phone-header-time">{{ phoneTime }}</div>
            <div class="phone-center">
              <div class="phone-ripple-container">
                <div class="phone-ripple r1"></div>
                <div class="phone-ripple r2"></div>
                <div class="phone-ripple r3"></div>
                <div class="phone-avatar-circle">
                  <svg width="56" height="56" viewBox="0 0 24 24" fill="white">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </div>
              </div>
              <div class="phone-caller-name">{{ currentInfoSource.callerName || '—' }}</div>
              <div class="phone-status-label">{{ translation.phoneIncoming || 'Appel entrant…' }}</div>
            </div>
            <div class="phone-action-bar">
              <div class="phone-answer-wrap">
                <button class="phone-answer-btn" @click="answerPhoneCall">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="white">
                    <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.29 21 3 13.71 3 4.5c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.24 1.02L6.62 10.79z"/>
                  </svg>
                </button>
                <div class="phone-answer-label">{{ translation.phoneAnswer || 'Répondre' }}</div>
              </div>
            </div>
          </div>

          <!-- ACTIVE CALL -->
          <div v-else class="phone-active">
            <div class="phone-active-top">
              <div class="phone-active-avatar">
                <svg width="44" height="44" viewBox="0 0 24 24" fill="white">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <div class="phone-caller-name">{{ currentInfoSource.callerName || '—' }}</div>
              <div class="phone-active-status">
                <span v-if="!phoneCallEnded" class="phone-active-dot"></span>
                <span>{{ phoneCallEnded ? (translation.phoneEnded || 'Appel terminé') : (translation.phoneActive || 'En communication…') }}</span>
              </div>
            </div>
            <audio ref="phoneAudio" :src="currentInfoSource.phoneAudioUrl" autoplay @ended="onPhoneAudioEnded" style="display:none"></audio>
            <transition name="phone-continue-fade">
              <div v-if="phoneCallAnswered" class="phone-continue-wrap">
                <button class="phone-continue-btn" @click="afterInfoComplete">
                  {{ translation.goToQuestions }}
                  <svg style="margin-right:8px;vertical-align:middle;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
                  </svg>
                </button>
              </div>
            </transition>
          </div>
        </div>
      </template>

      <!-- Non-phone layouts -->
      <template v-else>

      <!-- LAYOUT VERTICAL: Shorts / portrait video fullscreen -->
      <template v-if="currentInfoSource && currentInfoSource.withVideo && currentInfoSource.videoUrl && currentInfoSource.withVerticalVideo">
        <div class="info-vertical-video">
          <iframe
            class="vertical-iframe"
            :src="`https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1&rel=0`"
            allow="autoplay; encrypted-media; fullscreen"
            allowfullscreen
            :style="{ filter: `brightness(${videoBrightness}%)` }"
          ></iframe>
          <div class="vb-slider-wrap">
            <span class="vb-icon">☀️</span>
            <input type="range" v-model.number="videoBrightness" min="20" max="200" step="5" class="vb-slider" />
          </div>
          <div class="ar-top-btn-bar">
            <transition name="vv-btn-fade">
              <button v-if="showVerticalVideoContinue" class="ar-top-btn ar-top-btn--continue" @click="afterInfoComplete">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
                <span class="ar-top-btn-label">המשך</span>
              </button>
              <div v-else class="vv-loading-spinner">
                <svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg"><circle cx="22" cy="22" r="18" fill="none" stroke="rgba(255,255,255,0.35)" stroke-width="4"/><path d="M22 4 a18 18 0 0 1 18 18" fill="none" stroke="white" stroke-width="4" stroke-linecap="round"/></svg>
              </div>
            </transition>
          </div>
        </div>
      </template>

      <!-- LAYOUT A: text first, then video, then button -->
      <template v-if="currentInfoSource && currentInfoSource.withVideo && currentInfoSource.videoUrl && !currentInfoSource.withVerticalVideo">
        <div class="info-scroll-area">
          <div class="info-below-video">
            <div v-if="audioUrl && audioUrl.length > 5" class="info-audio-wrap">
              <audio id="audio" class="info-audio" controls :key="audioUrl">
                <source :src="audioUrl" type="audio/mp3" />
              </audio>
            </div>
            <div v-if="newInformationPointString" class="info-text">{{ newInformationPointString }}</div>
          </div>
          <div class="info-video-full" id="videoDiv" style="position:relative">
            <VueYoutube :video-id="videoId" :src="videoId" :player-vars="playerVars" @playing="playing"
              class="youtube-iframe"
              :style="{ filter: `brightness(${videoBrightness}%)` }" />
            <div class="vb-overlay">
              <span class="vb-icon">☀️</span>
              <input type="range" v-model.number="videoBrightness" min="20" max="200" step="5" class="vb-slider" />
            </div>
          </div>
        </div>
        <div class="info-btn-bar">
          <button v-if="showButtonInfoScreen" class="info-continue-btn" @click="afterInfoComplete">
            {{ translation.goToQuestions }} <svg style="margin-right:8px;vertical-align:middle;" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
          </button>
          <button v-else id="buttonContinueDisabled" class="info-continue-btn info-btn-waiting" @click="afterInfoComplete">
            {{ translation.goToQuestions }}
          </button>
        </div>
      </template>

      <!-- LAYOUT B: no video → scrollable card + fixed button -->
      <template v-else>
        <div class="info-card">
          <div class="info-header-icon">💡</div>
          <div v-if="audioUrl && audioUrl.length > 5" class="info-audio-wrap">
            <audio id="audio" class="info-audio" controls autoplay :key="audioUrl">
              <source :src="audioUrl" type="audio/mp3" />
            </audio>
          </div>
          <div v-if="newInformationPointString" class="info-text">{{ newInformationPointString }}</div>
        </div>
        <div class="info-btn-bar">
          <button v-if="showButtonInfoScreen" class="info-continue-btn" @click="afterInfoComplete">
            {{ translation.goToQuestions }} <svg style="margin-right:8px;vertical-align:middle;" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
          </button>
          <button v-else id="buttonContinueDisabled" class="info-continue-btn info-btn-waiting" @click="afterInfoComplete">
            {{ translation.goToQuestions }}
          </button>
        </div>
      </template>

      </template><!-- end non-phone -->

      </template><!-- end non-AR -->

    </div>
    <!-- END INFORMATION SCREEN -->

    <!-- END GAME DIALOG -->
    <div v-if="showLastDialog" class="endScreen" @click="showResults">
      <div v-for="n in 26" :key="n" class="confetti"></div>
      <audio controls loop autoplay style="display: none">
        <source src="../../static/sounds/endOfGame.mp3" type="audio/mp3" />
      </audio>

      <div class="endCard">
        <!-- Trophée -->
        <div class="endTrophy">🏆</div>

        <!-- Nom -->
        <div class="endName">{{ translation.wellDone }}<br/>{{ userName }} !</div>

        <!-- Score -->
        <div class="endScoreLabel">{{ translation.finishedTheGame }}</div>
        <div class="endScoreCircle">
          <span class="endScoreNumber">{{ errorNumber }}</span>
          <span class="endScoreUnit">pts</span>
        </div>

        <!-- Temps -->
        <div class="endTime">⏱ {{ gameSecondToTime }}</div>

        <!-- Bouton résultats -->
        <button class="endResultsBtn" @click="showResults">
          {{ translation.clickToResults }} <svg style="margin-right:8px;vertical-align:middle;" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
        </button>
      </div>
    </div>

    <!-- MAP (slides in from top) -->
    <!-- Map close button: outside #map so it has its own z-index above the bottom bar -->
    <button v-if="mapVisible" @click="removeMap" class="removeMapButton" aria-label="Close map">✕ &nbsp;סגור מפה</button>

    <div id="map">

      <!-- GPS permission modal -->
      <div v-if="showWarningB4Location" class="gps-modal-overlay" @click.self="showWarningB4Location = false">
        <div class="gps-modal">

          <!-- CAS 1 : permission refusée -->
          <template v-if="gpsStatus === 'denied'">
            <div class="gps-modal-icon">🚫</div>
            <div class="gps-modal-title">{{ gpsModalT.deniedTitle }}</div>
            <div class="gps-modal-text">{{ gpsModalT.deniedText }}</div>
            <div class="gps-modal-steps">
              <div class="gps-modal-step"><span class="gps-step-num">1</span>{{ gpsModalT.deniedStep1 }}</div>
              <div class="gps-modal-step"><span class="gps-step-num">2</span>{{ gpsModalT.deniedStep2 }}</div>
              <div class="gps-modal-step"><span class="gps-step-num">3</span>{{ gpsModalT.deniedStep3 }}</div>
            </div>
            <button class="gps-modal-btn gps-btn-close" @click="showWarningB4Location = false">{{ gpsModalT.close }}</button>
          </template>

          <!-- CAS 2 : première demande (unknown) -->
          <template v-else>
            <div class="gps-modal-icon">📍</div>
            <div class="gps-modal-title">{{ gpsModalT.unknownTitle }}</div>
            <div class="gps-modal-text">{{ gpsModalT.unknownText }}</div>
            <div class="gps-modal-steps">
              <div class="gps-modal-step"><span class="gps-step-num">✓</span>{{ gpsModalT.unknownStep1 }}</div>
              <div class="gps-modal-step"><span class="gps-step-num">✓</span>{{ gpsModalT.unknownStep2 }}</div>
            </div>
            <div class="gps-modal-actions">
              <button class="gps-modal-btn gps-btn-ok" @click="showCurrentPosition(); showWarningB4Location = false;">{{ gpsModalT.allow }}</button>
              <button class="gps-modal-btn gps-btn-close" @click="showWarningB4Location = false">{{ gpsModalT.cancel }}</button>
            </div>
          </template>

        </div>
      </div>

      <div v-if="showCurrentPositionButton" @click="gpsStatus === 'granted' ? showCurrentPosition() : showWarningB4Location = true" class="currentPosButton">
        <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
          class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
        </svg>
      </div>
      <div v-else @click="stopLocationUpdates" class="currentPosButton">
        {{ gpsModalT.removeLocation }}
      </div>

      <GMapMap v-if="pointsArrayOrder.length > 0 && Number(mapParameters.lat) && Number(mapParameters.lng)"
        :center="{ lat: Number(mapParameters.lat), lng: Number(mapParameters.lng) }" :zoom="Number(mapParameters.zoom)"
        map-type-id="satellite" :tilt="0" style="width: 100vw; height: calc(100vh - 80px)" :styles="myMapStyle" :options="{
          zoomControl: false,
          mapTypeControl: true,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: false,
          disableDefaultUi: false,
        }">
        <GMapMarker style="margin-right: 10px !important" :key="index" v-for="(m, index) in markers"
          :position="m.position" :clickable="true" :draggable="false"
          :label="{ text: `${index + 1}`, color: 'white', fontSize: '16px', fontWeight: 'bold' }" @click="center = m.position" />
        <GMapMarker v-if="showPosMarker"
          style="margin-right: 10px !important; height: 50px !important; width: 50px !important;" :clickable="true"
          :position="myCurrentPosition" :icon="iconImage" />
      </GMapMap>
    </div>

    <!-- ===== IN-GAME TUTORIAL OVERLAY ===== -->
    <template v-if="tutorialActive && tutorialStep >= 0">
      <!-- Click-blocker (invisible) -->
      <div class="tut-dark-bg" @click.stop></div>
      <!-- Spotlight hole -->
      <div v-if="tutSpot" class="tut-spotlight" :style="spotlightStyle"></div>
      <!-- Tooltip bubble -->
      <div class="tut-bubble" :style="tutBubbleStyle">
        <div class="tut-bubble-step">{{ tutorialStep + 1 }} / {{ navigationScreen === 'MissingWord' ? 7 : 5 }}</div>
        <div class="tut-bubble-text">{{ tutT.text }}</div>
        <div class="tut-bubble-actions">
          <button class="tut-btn-skip" @click.stop="endTutorial">{{ tutT.skipBtn }}</button>
          <button class="tut-btn-next" @click.stop="tutorialNext">{{ tutT.nextBtn }}</button>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
/* eslint-disable */
import Question from "./questions";
import Carousel from "./carousel";
import Puzzle from "./puzzle";
import MultipleMatch from "./multipleMatch";
import PhotoComponent from "./photoComponent";
import ImagesList from "./imagesList";
import DynamicMap from "./dynamicMap";
import MissingWord from "./missingWord";
import Memory from "./memory";
import JusteFaux from "./justeFaux";
import MotManquant from "./motManquant";
import RushHour from "./rushHour";
import SignCard from "./signCard";
import ArComponent from "./ar";
import VueYoutube from 'vue3-youtube';

export default {
  components: {
    Question,
    Carousel,
    Puzzle,
    MultipleMatch,
    PhotoComponent,
    ImagesList,
    DynamicMap,
    MissingWord,
    Memory,
    JusteFaux,
    MotManquant,
    RushHour,
    SignCard,
    ArComponent,
    VueYoutube,
  },

  data() {
    return {
      currentPoint: null,
      isReady: false,
      numberOfPoints: "5+",
      showCorrectAnswerIcon: false,
      showWongAnswerIcon: false,
      showStar: false,
      countdownTimer: '',
      playerVars: { autoplay: 1 },
      showWarningB4Location: false,
      gpsStatus: 'unknown', // 'unknown' | 'checking' | 'granted' | 'denied'
      gpsDeniedBannerVisible: false,
      userGeoFallback: null,
      pickedItem: "",
      showMultipleMatch: false,
      showPhotoComponent: false,
      showPuzzle: false,
      showQuestions: false,
      showMemory: false,
      showJusteFaux: false,
      showMotManquant: false,
      showRushHour: false,
      showSignCard: false,
      showMissingWord: false,
      showPosMarker: false,
      mapVisible: false,
      showButtonInfoScreen: false,
      iconImage: { url: require("../../static/img/circle.png") },
      watchPositionId: null,
      showCurrentPositionButton: true,
      myCurrentPosition: "",
      myMapStyle: {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      showPointInformation: false,
      showMainScreen: true,
      showPickedItem: false,
      phoneCallAnswered: false,
      phoneCallEnded: false,
      phoneRingSound: require('../../static/sounds/ring-phone.mp3'),
      gameSecondToTime: "",
      startTime: Date.now(),
      endTime: "",
      showLastDialog: false,
      errorNumber: 20,
      tutorialActive: false,
      tutorialStep: -1,
      tutSpot: null,
      showVerticalVideoContinue: false,
      videoBrightness: 100,
      pointNum: 0,
      pointNumForEvolution: 1,
      gameTimeInSecond: "",
      userKey: "",
      translationMissingWord: "Mot manquant sur l'image",
      translation: {
        clickToResults: "Cliquez pour les résultats",
        back: "Fermer",
        skipPoint: "Passer au point suivant",
        skipPointBeware: "Attention! Si vous ne trouvez pas la pancarte ou la réponse, vous pouvez passer au point suivant, cela vous coûtera 10 points.",
        mistakes: "Points",
        runningTime: "Temps écoulé",
        map: "Carte",
        pointNumber: "Sur la carte, repérez le nº",
        findMissingWord: "Rends-toi sur place et trouve l'inscription qui se trouve sur l'image ci-dessous.",
        didYouKnow: "Le saviez-vous ?",
        goToQuestions: "Continuer",
        wellDone: "Bien joué",
        correctAnswer: "C'est une bonne réponse !",
        continue: "Cliquez pour continuer.",
        wrongAnswer: "Ce n'est pas la bonne réponse.",
        tryAgain: "Cliquez pour réessayer.",
        visitOf: "Nous espérons que vous avez apprécié votre visite de",
        yourResults: "Vos résultats sont :",
        errorNumber: "Nombre de points :",
        totalTime: "Temps total :",
        goToRanking: "Avant de partir, vous pouvez aller jeter un coup d'oeil sur les résultats et voir en quelle position vous êtes arrivé(e) !",
        evolution: "Evolution",
        results: "Résultats",
        first: "",
        afterFirst: "",
        finishedTheGame: "Tu as terminé le parcours et voici ton résultat :",
      },
    };
  },

  watch: {
    showVerticalVideo(val) {
      const nav = document.querySelector('nav.navbar');
      const bar = this.$el?.querySelector('.bottomBar');
      if (nav) nav.style.visibility = val ? 'hidden' : '';
      if (bar) bar.style.visibility = val ? 'hidden' : '';
      if (val) {
        this.showVerticalVideoContinue = false;
        setTimeout(() => { this.showVerticalVideoContinue = true; }, 6000);
      } else {
        this.showVerticalVideoContinue = false;
      }
    },

    showArScreen(val) {
      const nav = document.querySelector('nav.navbar');
      if (nav) nav.style.visibility = val ? 'hidden' : '';
    },

    showPhoneScreen(val) {
      const nav = document.querySelector('nav.navbar');
      const bar = this.$el?.querySelector('.bottomBar');
      if (nav) nav.style.visibility = val ? 'hidden' : '';
      if (bar) bar.style.visibility = val ? 'hidden' : '';
      if (val) {
        // Create Audio object programmatically — more reliable than <audio autoplay>
        // nested inside multiple v-if layers where $refs can be null at $nextTick
        if (!this._ringAudio) {
          this._ringAudio = new Audio(this.phoneRingSound);
          this._ringAudio.loop = true;
        }
        this._ringAudio.currentTime = 0;
        this._ringAudio.play().catch(() => {});
      } else {
        if (this._ringAudio) {
          this._ringAudio.pause();
          this._ringAudio.currentTime = 0;
        }
      }
    },

    currentPointData: {
      immediate: true,
      handler(newVal) {
        if (newVal?.navigationScreen === 'dynamicMap' && this.gpsStatus === 'unknown') {
          this.checkGpsPermission();
        }
      },
    },

    gpsStatus(newVal) {
      if (newVal === 'denied') {
        this.gpsDeniedBannerVisible = true;
        setTimeout(() => { this.gpsDeniedBannerVisible = false; }, 4000);
      }
    },

    pointNum(newVal) {
      localStorage.setItem("pointNumber", newVal);
      if (this.points && this.pointsArrayOrder) {
        const key = this.pointsArrayOrder[newVal - 1] - 1;
        const currentData = this.points[key];
        if (currentData) {
          if (currentData.timePerPoint) {
            localStorage.setItem("timePerPoint", currentData.timePerPoint);
          }
        }
      }
      this.checkElementPicked();
    },
    // Auto-save phase flags so reload always restores the correct screen
    showMainScreen(val) {
      localStorage.setItem("showMainScreen", val);
      if (val) this.$nextTick(() => this.maybeStartScreenTutorial());
    },
    showPointInformation(val) {
      localStorage.setItem("showPointInformation", val);
    },
    showPickedItem(val) {
      localStorage.setItem("showPickedItem", val);
    },
    showQuestions(val) { localStorage.setItem("showQuestions", val); },
    showMultipleMatch(val) { localStorage.setItem("showMultipleMatch", val); },
    showPhotoComponent(val) { localStorage.setItem("showPhotoComponent", val); },
    showMemory(val) { localStorage.setItem("showMemory", val); },
    showJusteFaux(val) { localStorage.setItem("showJusteFaux", val); },
    showMotManquant(val) { localStorage.setItem("showMotManquant", val); },
    showRushHour(val) { localStorage.setItem("showRushHour", val); },
    showSignCard(val) { localStorage.setItem("showSignCard", val); },

    mapVisible(val) {
      if (val && this.tutorialActive && this.tutorialStep === 1) {
        this.$nextTick(() => { this.tutorialStep = 2; this.updateTutorialSpot(); });
      }
    },

    navigationScreen(newVal) {
      if (newVal === 'ImagesList' || newVal === 'MissingWord' || newVal === 'DynamicMap') {
        this.$nextTick(() => this.maybeStartScreenTutorial());
      }
    },
  },

  mounted() {
    this.isReady = false;
    fetch('https://ip-api.com/json/?fields=lat,lon,status')
      .then(r => r.json())
      .then(d => { if (d.status === 'success') this.userGeoFallback = { lat: d.lat, lng: d.lon, zoom: 13 }; })
      .catch(() => {});

    // Safe JSON parse: handles null, the string "undefined", and malformed JSON
    const safeParse = (key, fallback) => {
      try {
        const val = localStorage.getItem(key);
        if (val === null || val === 'undefined') return fallback;
        return JSON.parse(val);
      } catch {
        return fallback;
      }
    };

    // 1. Check that game data is cached — if not, try to fetch via route param
    const cachedPoints = localStorage.getItem("allPointsData");
    const cachedOrder = safeParse("pointsArrayOrder", null);

    if (!cachedPoints || !cachedOrder) {
      const routeGameName = this.$route?.params?.gameName;
      if (routeGameName) {
        // Arrived directly via /:gameName URL — fetch data then re-mount at /play
        localStorage.setItem("navigationName", routeGameName);
        this.$store.dispatch("fetchPoints", routeGameName)
          .then(() => {
            const pts = this.$store.getters.points;
            const ord = this.$store.getters.pointsArrayOrder;
            if (pts) localStorage.setItem("allPointsData", JSON.stringify(pts));
            if (ord) localStorage.setItem("pointsArrayOrder", JSON.stringify(ord));
            // Rebuild arrayOfImagesBase64 from fresh points so stale images are replaced
            if (pts && pts.length) {
              const fresh = pts.map(p => p?.imageBase64 || p?.imageUrl || '');
              this.$store.commit('setArrayOfImagesBase64', fresh);
              try { localStorage.setItem('arrayOfImagesBase64', JSON.stringify(fresh)); } catch(e) {}
            }
            this.$router.replace("/play");
          })
          .catch(() => this.$router.push("/"));
        return;
      }
      const navigationName = localStorage.getItem("navigationName");
      this.$router.push(navigationName ? "/" + navigationName : "/");
      return;
    }

    // 2. Hydrate the Vuex store from cache
    this.$store.commit("setPoints", JSON.parse(cachedPoints));
    this.$store.commit("setPointsArray", cachedOrder);

    const gameParameters = safeParse("gameParameters", null);
    if (gameParameters) {
      this.$store.commit("setGameParameters", gameParameters);
    }

    // 2b. Hydrate questions from localStorage (available offline)
    const cachedQuestions = safeParse("questionsArray", null);
    if (cachedQuestions && cachedQuestions.length) {
      this.$store.commit("setQuestionsArray", cachedQuestions);
      this.$store.commit("setQuestionsSuffled", cachedQuestions);
    }

    // 3. Restore all saved progress
    this.userKey = localStorage.getItem("userKey") || "";
    this.pointNumForEvolution = parseInt(localStorage.getItem("pointNumForEvolution")) || 1;
    this.errorNumber = parseInt(safeParse("errorNumber", 20)) || 20;
    this.startTime = parseInt(localStorage.getItem("startTime")) || Date.now();

    // 4. Restore which screen was showing (Phase 1 / 2 / 3)
    //    Default: show main screen if nothing was saved
    this.showMainScreen = safeParse("showMainScreen", true);
    this.showPickedItem = safeParse("showPickedItem", false);
    this.showPointInformation = safeParse("showPointInformation", false);

    // 5. Restore point index — set before checkElementPicked so currentPointData is valid
    const savedPoint = localStorage.getItem("pointNumber");
    const restoredPointNum = savedPoint ? parseInt(savedPoint) : 0;
    // Assign directly without triggering watcher side-effects prematurely
    this.pointNum = restoredPointNum;

    // 6. If Phase 3 (exercise) was showing, re-derive the correct sub-flag and currentPoint
    //    from the actual point data rather than from saved flags (more reliable)
    if (this.showPickedItem) {
      this.$nextTick(() => this.checkElementPicked());
    }

    this.translate(this.$store.getters.lang);
    this.isReady = true;

    if (localStorage.getItem('inGameTutorial') === 'true') {
      this.tutorialActive = true;
      this.tutorialStep = 0;
      this.$nextTick(() => this.updateTutorialSpot());
    } else {
      this.$nextTick(() => this.maybeStartScreenTutorial());
    }
  },

  computed: {
    tutT() {
      const lang = this.$store.getters.lang || 'he';
      const map = {
        he: {
          steps: [
            'זהו מספר התחנה הבאה — מצאו אותו על המפה!',
            'לחצו כאן כדי לפתוח את המפה ולאתר את יעדכם',
            'כפתור זה סוגר את המפה',
            'כפתור זה מציג את המיקום שלכם על המפה',
            'זוהי תמונת הרמז — בדקו מה חסר בה',
            'כתבו כאן את המילה החסרה',
            'תקועים? דלגו לנקודה הבאה — אבל זה יעלה 10 נקודות',
          ],
          ilStep4: 'כשתגיעו למקום, בחרו את התמונה שניתן לראות בסביבה הקרובה',
          dmStep4: 'המפה מציגה את המסלול לנקודה הבאה. עקבו אחר הנתיב עד שתגיעו',
          next: '← הבא', done: '!הבנתי', skip: 'דלג על ההסבר',
        },
        fr: {
          steps: [
            "C'est le numéro de votre prochaine étape — trouvez-le sur la carte !",
            "Touchez ici pour ouvrir la carte et trouver votre destination",
            "Ce bouton referme la carte",
            "Ce bouton affiche votre position sur la carte",
            "Voici l'indice photo — regardez ce qui est caché",
            "Écrivez le mot manquant ici",
            "Bloqué ? Passez au point suivant — mais ça coûte 10 points !",
          ],
          ilStep4: "Une fois sur place, appuyez sur l'image que vous pouvez voir dans les environs tout proches",
          dmStep4: "Une carte affiche l'itinéraire jusqu'au prochain point. Suivez le chemin indiqué jusqu'à votre arrivée",
          next: 'Suivant →', done: "J'ai compris !", skip: "Passer l'explication",
        },
        en: {
          steps: [
            "This is your next stop number — find it on the map!",
            "Tap here to open the map and find your destination",
            "This button closes the map",
            "This button shows your location on the map",
            "This is the photo clue — look at what's hidden",
            "Write the missing word here",
            "Stuck? Skip to the next point — but it costs 10 points!",
          ],
          ilStep4: "Once you're there, tap the image that matches something you can see in the immediate surroundings",
          dmStep4: "A map shows the route to the next point. Follow the path until you arrive",
          next: 'Next →', done: 'Got it!', skip: 'Skip explanation',
        },
        ar: {
          steps: [
            "هذا رقم محطتك التالية — ابحث عنه على الخريطة!",
            "اضغط هنا لفتح الخريطة والعثور على وجهتك",
            "هذا الزر يغلق الخريطة",
            "هذا الزر يعرض موقعك على الخريطة",
            "هذه صورة الدليل — انظر ما هو مخفي فيها",
            "اكتب الكلمة المفقودة هنا",
            "عالق؟ انتقل إلى النقطة التالية — لكنها ستكلفك 10 نقاط!",
          ],
          ilStep4: "بمجرد وصولك، اضغط على الصورة التي يمكنك رؤيتها في المحيط القريب",
          dmStep4: "تعرض الخريطة المسار إلى النقطة التالية. اتبع الطريق حتى تصل",
          next: '← التالي', done: 'فهمت!', skip: 'تخطي الشرح',
        },
        de: {
          steps: [
            "Das ist die Nummer Ihrer nächsten Station — finden Sie sie auf der Karte!",
            "Tippen Sie hier, um die Karte zu öffnen und Ihr Ziel zu finden",
            "Diese Schaltfläche schließt die Karte",
            "Diese Schaltfläche zeigt Ihren Standort auf der Karte an",
            "Das ist der Foto-Hinweis — schauen Sie, was verborgen ist",
            "Schreiben Sie das fehlende Wort hier",
            "Nicht weitergekommen? Überspringen — kostet aber 10 Punkte!",
          ],
          ilStep4: "Sobald Sie dort sind, tippen Sie auf das Bild, das Sie in der näheren Umgebung sehen können",
          dmStep4: "Eine Karte zeigt die Route zum nächsten Punkt. Folgen Sie dem Weg, bis Sie ankommen",
          next: 'Weiter →', done: 'Verstanden!', skip: 'Erklärung überspringen',
        },
      };
      const t = map[lang] || map.he;
      const screen = this.navigationScreen;
      const isMW = screen === 'MissingWord';
      const maxStep = isMW ? 6 : 4;
      const isLast = this.tutorialStep >= maxStep;
      let stepText;
      if (this.tutorialStep === 4 && screen === 'ImagesList') stepText = t.ilStep4;
      else if (this.tutorialStep === 4 && screen === 'DynamicMap') stepText = t.dmStep4;
      else stepText = t.steps[this.tutorialStep] || '';
      return {
        text: stepText,
        nextBtn: isLast ? t.done : t.next,
        skipBtn: t.skip,
      };
    },

    spotlightStyle() {
      if (!this.tutSpot) return {};
      return {
        left: (this.tutSpot.x - 10) + 'px',
        top: (this.tutSpot.y - 10) + 'px',
        width: (this.tutSpot.w + 20) + 'px',
        height: (this.tutSpot.h + 20) + 'px',
      };
    },

    tutBubbleStyle() {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const bubbleW = Math.min(310, vw - 32);
      if (!this.tutSpot) {
        return { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: bubbleW + 'px' };
      }
      const { x, y, w, h } = this.tutSpot;
      const centerX = x + w / 2;
      const isBottomHalf = (y + h / 2) > vh / 2;
      const left = Math.max(16, Math.min(centerX - bubbleW / 2, vw - bubbleW - 16));
      if (isBottomHalf) {
        return { position: 'fixed', bottom: (vh - y + 16) + 'px', left: left + 'px', width: bubbleW + 'px' };
      }
      return { position: 'fixed', top: (y + h + 16) + 'px', left: left + 'px', width: bubbleW + 'px' };
    },

    showVerticalVideo() {
      return !!(this.showPointInformation && this.currentInfoSource?.withVerticalVideo);
    },

    showArScreen() {
      return !!(this.showPointInformation && this.currentInfoSource?.withAR);
    },

    showPhoneScreen() {
      return !!(this.showPointInformation && this.currentInfoSource?.withPhone);
    },

    phoneTime() {
      const now = new Date();
      return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
    },

    currentSmiley() {
      if (this.showLastDialog || this.showCorrectAnswerIcon) return 'enthusiastic';
      if (this.showWongAnswerIcon) return 'disgusted';
      if ((this.showPuzzle || this.showPhotoComponent) && this.showPickedItem) return 'proud';
      if (this.showPickedItem && (this.showQuestions || this.showMultipleMatch)) return 'thinking';
      if (this.showPointInformation) return 'smile';
      return null;
    },

    isHistoireMode() {
      return (this.gameParameters.questionsOrder === 'sorted');
    },

    // Points triés par numéro — source de contenu en mode Histoire
    contentPoints() {
      const pts = this.points;
      if (!pts) return [];
      const arr = Array.isArray(pts) ? pts : Object.values(pts);
      return [...arr].sort((a, b) => Number(a.pointNumber) - Number(b.pointNumber));
    },

    currentStoryItem() {
      if (!this.isHistoireMode) return null;
      return this.contentPoints[this.pointNum] || null;
    },

    currentPointData() {
      const points = this.points;
      const order = this.pointsArrayOrder;
      if (!points || !order || order[this.pointNum] === undefined) return null;
      // pointsArrayOrder stores 1-based pointNumber values; after null-filtering
      // the points array is 0-indexed, so subtract 1 to get the correct entry.
      return points[order[this.pointNum] - 1] || null;
    },

    navigationScreen() {
      if (!this.currentPointData) return null;
      const screen = this.currentPointData.navigationScreen;
      // GPS denied → fall back silently to imagesList
      if (screen === 'dynamicMap' && this.gpsStatus === 'denied') return 'ImagesList';
      switch (screen) {
        case 'dynamicMap': return 'DynamicMap';
        case 'missingWord': return 'MissingWord';
        case 'imagesList': return 'ImagesList';
        case 'carousel': return 'Carousel';
        default: return 'ImagesList';
      }
    },

    gpsPromptVisible() {
      return this.currentPointData?.navigationScreen === 'dynamicMap' &&
        (this.gpsStatus === 'unknown' || this.gpsStatus === 'checking');
    },

    videoId() {
      if (this.isHistoireMode) {
        return this.currentStoryItem?.videoUrl || '';
      }
      const point = this.points[this.pointsArrayOrder[this.pointNum] - 1];
      if (point && point.videoUrl) {
        localStorage.setItem("videoUrl", point.videoUrl);
        return point.videoUrl;
      }
      return localStorage.getItem("videoUrl");
    },

    newInformationPointString() {
      const src = this.isHistoireMode ? this.currentStoryItem : this.currentPointData;
      const info = src?.pointInformation;
      if (!info || !info.toString().trim()) return "";
      return info.toString().trim().replaceAll("\n", "\n");
    },

    audioUrl() {
      if (this.isHistoireMode) {
        const url = this.currentStoryItem?.audioUrl || "";
        return (url && url.trim().length > 5) ? url : "";
      }
      const index = this.pointsArrayOrder[this.pointNum] - 1;
      const point = this.points ? this.points[index] : null;
      let url = "";
      if (this.gameParameters.questionsOrder === "linkedToPointNumber" && point) {
        url = point.audioUrl;
      } else {
        const storeAudio = this.$store.getters.arrayOfAudioUrl;
        url = storeAudio ? storeAudio[this.pointNum] : "";
      }
      return (url && typeof url === 'string' && url.trim() !== "") ? url : "";
    },

    mapParameters() {
      // mapParameters is the game-wide map center, stored by fetchGameData
      const cached = localStorage.getItem("mapParameters");
      if (cached) {
        try { return JSON.parse(cached); } catch { }
      }
      return this.$store.getters.mapParameters || this.userGeoFallback || { lat: 32.657, lng: 35.417, zoom: 15 };
    },

    gameParameters() {
      return this.$store.getters.gameParameters || {};
    },

    gpsModalT() {
      const lang = this.$store.getters.lang || 'fr';
      const t = {
        fr: {
          unknownTitle: '📍 Voir votre position sur la carte',
          unknownText: 'Votre téléphone va vous demander l\'autorisation d\'accéder à votre position. Pour que ça fonctionne :',
          unknownStep1: 'Appuyez sur "Autoriser" quand la demande apparaît',
          unknownStep2: 'Si rien ne s\'affiche, vérifiez que la localisation est activée dans les réglages de votre téléphone',
          allow: '📍 Activer ma position',
          cancel: 'Annuler',
          deniedTitle: '🚫 Localisation refusée',
          deniedText: 'Vous avez refusé l\'accès à votre position. Pour l\'autoriser maintenant :',
          deniedStep1: 'Ouvrez les Réglages de votre téléphone',
          deniedStep2: 'Allez dans Confidentialité → Localisation (iOS) ou Applis → Navigateur → Autorisations (Android)',
          deniedStep3: 'Activez la localisation pour ce site, puis revenez et réessayez',
          close: 'Fermer',
          removeLocation: 'Masquer ma position',
        },
        he: {
          unknownTitle: '📍 הצג את מיקומך על המפה',
          unknownText: 'הטלפון שלך יבקש רשות לגשת למיקומך. כדי שזה יעבוד:',
          unknownStep1: 'לחץ "אפשר" כשהבקשה מופיעה',
          unknownStep2: 'אם כלום לא מופיע, בדוק שהמיקום מופעל בהגדרות הטלפון',
          allow: '📍 הפעל מיקום',
          cancel: 'ביטול',
          deniedTitle: '🚫 הגישה למיקום נדחתה',
          deniedText: 'דחית גישה למיקום. כדי לאפשר אותה עכשיו:',
          deniedStep1: 'פתח את הגדרות הטלפון',
          deniedStep2: 'עבור לפרטיות ← מיקום (iOS) או אפליקציות ← דפדפן ← הרשאות (Android)',
          deniedStep3: 'הפעל מיקום לאתר זה, חזור ונסה שוב',
          close: 'סגור',
          removeLocation: 'הסתר מיקום',
        },
        en: {
          unknownTitle: '📍 Show your position on the map',
          unknownText: 'Your phone will ask permission to access your location. For it to work:',
          unknownStep1: 'Tap "Allow" when the prompt appears',
          unknownStep2: 'If nothing appears, make sure location is enabled in your phone settings',
          allow: '📍 Enable my location',
          cancel: 'Cancel',
          deniedTitle: '🚫 Location access denied',
          deniedText: 'You previously denied location access. To enable it now:',
          deniedStep1: 'Open your phone\'s Settings',
          deniedStep2: 'Go to Privacy → Location (iOS) or Apps → Browser → Permissions (Android)',
          deniedStep3: 'Enable location for this site, then come back and try again',
          close: 'Close',
          removeLocation: 'Hide my location',
        },
        ar: {
          unknownTitle: '📍 إظهار موقعك على الخريطة',
          unknownText: 'سيطلب هاتفك إذناً للوصول إلى موقعك. لكي يعمل:',
          unknownStep1: 'اضغط "السماح" عند ظهور الطلب',
          unknownStep2: 'إذا لم يظهر شيء، تأكد من تفعيل الموقع في إعدادات هاتفك',
          allow: '📍 تفعيل موقعي',
          cancel: 'إلغاء',
          deniedTitle: '🚫 تم رفض الوصول إلى الموقع',
          deniedText: 'لقد رفضت الوصول إلى موقعك سابقاً. لتفعيله الآن:',
          deniedStep1: 'افتح إعدادات هاتفك',
          deniedStep2: 'انتقل إلى الخصوصية ← الموقع (iOS) أو التطبيقات ← المتصفح ← الأذونات (Android)',
          deniedStep3: 'فعّل الموقع لهذا الموقع ثم عد وحاول مرة أخرى',
          close: 'إغلاق',
          removeLocation: 'إخفاء موقعي',
        },
      };
      return t[lang] || t.fr;
    },

    userName() {
      return this.$store.getters.user?.userName
        || localStorage.getItem("myNameOuchui")
        || "Guest";
    },

    points() {
      // Read from Vuex first (reactive — updates when store commits happen)
      const vuexPoints = this.$store.getters.points;
      if (vuexPoints && vuexPoints.length > 0) return vuexPoints;
      // Fallback to localStorage (for initial load before Vuex is hydrated)
      if (localStorage.getItem("allPointsData")) {
        return JSON.parse(localStorage.getItem("allPointsData"));
      }
      return this.$store.getters.points;
    },

    markers() {
      // Prefer localStorage (populated by fetchGameData), fall back to Vuex store
      const cached = localStorage.getItem("markers");
      const raw = cached ? JSON.parse(cached) : this.$store.getters.markers;
      if (!raw) return [];
      const arr = Array.isArray(raw) ? raw : Object.values(raw);
      return arr
        .filter(m => m && m.lat !== undefined && m.lng !== undefined)
        .map(m => ({ position: { lat: parseFloat(m.lat), lng: parseFloat(m.lng) } }));
    },

    pointsArrayOrder() {
      const cached = localStorage.getItem("pointsArrayOrder");
      return cached ? JSON.parse(cached) : this.$store.getters.pointsArrayOrder || [];
    },

    group() {
      return this.$store.getters.group;
    },

    questions() {
      return this.$store.getters.questions;
    },

    // Source de données pour l'écran d'info : story item en mode histoire, sinon point GPS
    currentInfoSource() {
      return this.isHistoireMode ? this.currentStoryItem : this.currentPointData;
    },

    currentPointHasInfo() {
      const invalid = ['', 'null', 'undefined', 'none'];
      const clean = v => v && typeof v === 'string' ? v.trim().toLowerCase() : '';
      const hasAudio = this.audioUrl && this.audioUrl.trim().length > 5 && !invalid.includes(clean(this.audioUrl));
      const hasText  = !!(this.newInformationPointString && this.newInformationPointString.trim());
      const src = this.isHistoireMode ? this.currentStoryItem : this.currentPointData;
      const videoUrl = src?.videoUrl;
      const withVideo = src?.withVideo;
      const hasVideo = withVideo && videoUrl && videoUrl.trim().length > 5 && !invalid.includes(clean(videoUrl));
      const hasAR = !!(src?.withAR);
      const hasPhone = !!(src?.withPhone);
      return !!(hasAudio || hasText || hasVideo || hasAR || hasPhone);
    },

    currentPointHasExercise() {
      if (this.isHistoireMode) {
        const item = this.currentStoryItem;
        if (!item) return false;
        const type = (item.picked || '').toString().trim().toLowerCase();
        if (type === 'puzzle' || type === 'multiplematch' || type === 'memory' || type === 'justefaux' || type === 'motmanquant' || type === 'rushhour' || type === 'signcard' || type === 'photocomponent') return true;
        // Questions : vérifier dans le store liées à item.pointNumber
        const sources = [this.$store.getters.questions, this.$store.getters.questionsShuffled, this.$store.getters.questionsArray];
        for (const qs of sources) {
          if (!qs) continue;
          const arr = Array.isArray(qs) ? qs : Object.values(qs);
          if (arr.some(q => String(q.pointLinked) === String(item.pointNumber))) return true;
        }
        return false;
      }
      const p = this.currentPointData;
      if (!p) return false;
      const type = (p.picked || '').toString().trim().toLowerCase();
      if (type === 'puzzle' || type === 'multiplematch' || type === 'memory' || type === 'justefaux' || type === 'motmanquant' || type === 'rushhour' || type === 'signcard' || type === 'photocomponent') return true;
      // questions may land in any of these three stores depending on randomQuestions setting
      const sources = [
        this.$store.getters.questions,
        this.$store.getters.questionsShuffled,
        this.$store.getters.questionsArray,
      ];
      for (const qs of sources) {
        if (!qs) continue;
        const arr = Array.isArray(qs) ? qs : Object.values(qs);
        if (arr.some(q => String(q.pointLinked) === String(p.pointNumber))) return true;
      }
      return false;
    },
  },

  methods: {

    getSmileyStyle(smiley) {
      if (smiley === 'proud')       return { width: '86px',    height: '84px', objectFit: 'contain', position: 'relative', top: '3px',  left: '-5px' };
      if (smiley === 'smile')       return { width: '89px',    height: '85px', objectFit: 'contain', position: 'relative', top: '4px',  left: '-6px' };
      if (smiley === 'thinking')    return { width: 'auto',    height: '96px', objectFit: 'contain', position: 'relative', top: '10px', left: '0px' };
      if (smiley === 'enthusiastic') return { width: 'auto',   height: '105px', objectFit: 'contain', position: 'relative', top: '-14px', left: '0px' };
      return { width: '80px', height: '80px', objectFit: 'contain', position: 'relative', top: '0px', left: '0px' };
    },
    // Phase 1 — Navigation
    answerPhoneCall() {
      // Stop the ring sound (programmatic Audio object)
      if (this._ringAudio) {
        this._ringAudio.pause();
        this._ringAudio.currentTime = 0;
      }
      this.phoneCallAnswered = true;
      this.$nextTick(() => {
        const audio = this.$refs.phoneAudio;
        if (audio) audio.play().catch(() => {});
      });
    },

    onPhoneAudioEnded() {
      this.phoneCallEnded = true;
    },

    showNavigation() {
      this.showMainScreen = true;
      this.showPointInformation = false;
      this.showPickedItem = false;
      this.showQuestions = false;
      this.showMultipleMatch = false;
      this.showPhotoComponent = false;
      this.showMemory = false;
      this.showJusteFaux = false;
      this.showMotManquant = false;
      this.showRushHour = false;
      this.showSignCard = false;
      this.showPuzzle = false;
      this.phoneCallAnswered = false;
      this.phoneCallEnded = false;
      if (this._ringAudio) { this._ringAudio.pause(); this._ringAudio.currentTime = 0; }
      // Restore navbar/bottom bar visibility if phone screen was showing
      const nav = document.querySelector('nav.navbar');
      const bar = this.$el?.querySelector('.bottomBar');
      if (nav) nav.style.visibility = '';
      if (bar) bar.style.visibility = '';
      localStorage.setItem("showMainScreen", true);
      localStorage.setItem("showPointInformation", false);
      localStorage.setItem("showPickedItem", false);
      localStorage.setItem("showQuestions", false);
      localStorage.setItem("showMultipleMatch", false);
      localStorage.setItem("showPhotoComponent", false);
      localStorage.setItem("showMemory", false);
      localStorage.setItem("showJusteFaux", false);
      localStorage.setItem("showMotManquant", false);
      localStorage.setItem("showSignCard", false);
      localStorage.setItem("showPuzzle", false);
    },

    // Phase 2 — Information (audio / video / text)
    showInfoScreen() {
      if (!this.currentPointHasInfo) {
        if (this.currentPointHasExercise) { this.showPickedItemDiv(); }
        else { this.nextPointNumber(); this.showNavigation(); }
        return;
      }
      this.showMainScreen = false;
      this.showPointInformation = true;
      this.showPickedItem = false;
      localStorage.setItem("showMainScreen", false);
      localStorage.setItem("showPointInformation", true);
      localStorage.setItem("showPickedItem", false);
    },

    // Phase 3 — Exercise (questions, puzzle, etc.)
    showPickedItemDiv() {
      this.checkElementPicked();
      this.showMainScreen = false;
      this.showPointInformation = false;
      this.showPickedItem = true;
      this.showButtonInfoScreen = false;
      localStorage.setItem("showMainScreen", false);
      localStorage.setItem("showPointInformation", false);
      localStorage.setItem("showPickedItem", true);
    },

    saveToLocalStorage() {
      localStorage.setItem("pointNumber", this.pointNum);
      localStorage.setItem("pointNumForEvolution", this.pointNumForEvolution);
      localStorage.setItem("errorNumber", this.errorNumber);
      localStorage.setItem("showMainScreen", this.showMainScreen);
      localStorage.setItem("showPointInformation", this.showPointInformation);
      localStorage.setItem("showPickedItem", this.showPickedItem);
      localStorage.setItem("showPuzzle", this.showPuzzle);
      localStorage.setItem("pickedItem", this.pickedItem);
      localStorage.setItem("startTime", this.startTime);
    },

    onPuzzleDone() {
      this.showPuzzle = false;
      this.showPickedItem = false;
      this.showMainScreen = true;
      this.nextPointNumber();
      this.showNavigation();
    },

    onPuzzleStarUp(score) {
      this.errorNumber += score;
      this.showStarUp(score);
      localStorage.setItem("errorNumber", this.errorNumber);
    },

    onMemoryDone() {
      this.showMemory = false;
      this.showPickedItem = false;
      this.showMainScreen = true;
      this.nextPointNumber();
      this.showNavigation();
    },

    onJusteFauxDone() {
      this.showJusteFaux = false;
      this.showPickedItem = false;
      this.showMainScreen = true;
      this.nextPointNumber();
      this.showNavigation();
      window.scrollTo(0, 0);
    },

    onMotManquantDone() {
      this.showMotManquant = false;
      this.showPickedItem = false;
      this.showMainScreen = true;
      this.nextPointNumber();
      this.showNavigation();
      window.scrollTo(0, 0);
    },

    onRushHourDone() {
      this.showRushHour = false;
      this.showPickedItem = false;
      this.showMainScreen = true;
      this.nextPointNumber();
      this.showNavigation();
      window.scrollTo(0, 0);
    },

    onSignCardDone() {
      this.showSignCard = false;
      this.showPickedItem = false;
      this.showMainScreen = true;
      this.nextPointNumber();
      this.showNavigation();
      window.scrollTo(0, 0);
    },

    onMemoryStarUp(score) {
      this.errorNumber += score;
      this.showStarUp(score);
      localStorage.setItem("errorNumber", this.errorNumber);
    },

    showStarUp(numberOfPoints) {
      this.numberOfPoints = numberOfPoints;
      this.showStar = true;
      setTimeout(() => { this.showStar = false; }, 2000);
    },

    playing() { },

    reopenGame() {
      const navigationName = localStorage.getItem("navigationName");
      if (navigationName) {
        this.$router.push("/" + navigationName);
        location.reload();
      } else {
        this.$router.push("/");
        location.reload();
      }
    },

    stopLocationUpdates() {
      this.showPosMarker = false;
      this.showCurrentPositionButton = true;
      navigator.geolocation.clearWatch(this.watchPositionId);
    },

    showCurrentPosition() {
      if (!navigator.geolocation) {
        alert("La géolocalisation n'est pas prise en charge par ce navigateur.");
        return;
      }
      this.showCurrentPositionButton = false;
      this.watchPositionId = navigator.geolocation.watchPosition(
        (position) => {
          this.myCurrentPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.showPosMarker = true;
        },
        (error) => {
          console.error('Geolocation error:', error.code, error.message);
          this.showCurrentPositionButton = true;
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      );
    },

    async checkGpsPermission() {
      if (!navigator.geolocation) {
        this.gpsStatus = 'denied';
        return;
      }
      if (navigator.permissions) {
        try {
          const result = await navigator.permissions.query({ name: 'geolocation' });
          if (result.state === 'granted') { this.gpsStatus = 'granted'; return; }
          if (result.state === 'denied')  { this.gpsStatus = 'denied';  return; }
          // 'prompt' → fall through to show our UI
        } catch (e) {
          // Permissions API not supported (old iOS) → show our UI
        }
      }
      this.gpsStatus = 'unknown';
    },

    async requestGpsPermission() {
      this.gpsStatus = 'checking';
      try {
        await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 0,
          });
        });
        this.gpsStatus = 'granted';
      } catch (e) {
        // code 1 = PERMISSION_DENIED, anything else = GPS unavailable but permission not denied
        this.gpsStatus = e.code === 1 ? 'denied' : 'granted';
      }
    },

    skipGpsPermission() {
      this.gpsStatus = 'denied';
    },

    translate(lang) {
      switch (lang) {
        case "fr":
          this.translationMissingWord = "Mot manquant sur l'image";
          this.translation = {
            clickToResults: "Cliquez pour les résultats",
            back: "Fermer",
            skipPoint: "Passer au point suivant",
            skipPointBeware: "Attention! Si vous ne trouvez pas la pancarte ou la réponse, vous pouvez passer au point suivant, cela vous coûtera 10 points.",
            mistakes: "Points",
            runningTime: "Temps écoulé",
            map: "Carte",
            pointNumber: "Sur la carte, repérez le nº",
            findMissingWord: "Rends-toi sur place et trouve l'inscription qui se trouve sur l'image ci-dessous.",
            didYouKnow: "Le saviez-vous ?",
            goToQuestions: "Continuer",
            wellDone: "Bien joué",
            correctAnswer: "C'est une bonne réponse !",
            continue: "Cliquez pour continuer.",
            wrongAnswer: "Ce n'est pas la bonne réponse.",
            tryAgain: "Cliquez pour réessayer.",
            visitOf: "Nous espérons que vous avez apprécié votre visite de",
            yourResults: "Vos résultats sont :",
            errorNumber: "Nombre de points :",
            totalTime: "Temps total :",
            goToRanking: "Avant de partir, vous pouvez aller jeter un coup d'oeil sur les résultats et voir en quelle position vous êtes arrivé(e) !",
            evolution: "Evolution",
            results: "Résultats",
            first: "",
            afterFirst: "",
            finishedTheGame: "Tu as terminé le parcours et voici ton résultat :",
            phoneIncoming: "Appel entrant…",
            phoneAnswer: "Répondre",
            phoneActive: "En communication…",
            phoneEnded: "Appel terminé",
          };
          break;
        case "he":
          this.translationMissingWord = "מילה חסרה בתמונה";
          this.translation = {
            clickToResults: "לחץ לתוצאות",
            back: "סגור",
            skipPoint: "דלג לנקודה הבאה",
            skipPointBeware: "שימו לב! אם אינכם מוצאים את השלט או את התשובה, תוכלו לדלג לנקודה הבאה, אך זה יעלה לכם 10 נקודות.",
            mistakes: "נקודות",
            runningTime: "זמן שחלף",
            map: "מפה",
            pointNumber: "במפה, מצאו את מספר",
            findMissingWord: "גשו למקום ומצאו את הכתובת שמופיעה בתמונה למטה.",
            didYouKnow: "האם ידעת?",
            goToQuestions: "המשך",
            wellDone: "כל הכבוד",
            correctAnswer: "תשובה נכונה!",
            continue: "לחץ להמשך.",
            wrongAnswer: "זו לא התשובה הנכונה.",
            tryAgain: "לחץ לנסות שוב.",
            visitOf: "אנו מקווים שנהניתם מהביקור ב",
            yourResults: "התוצאות שלך:",
            errorNumber: "מספר נקודות:",
            totalTime: "זמן כולל:",
            goToRanking: "לפני שאתם עוזבים, תוכלו לבדוק את הדירוג ולראות באיזה מקום סיימתם!",
            evolution: "התקדמות",
            results: "תוצאות",
            first: "",
            afterFirst: "",
            finishedTheGame: "סיימתם את המסלול והנה התוצאה שלכם:",
            phoneIncoming: "שיחה נכנסת…",
            phoneAnswer: "ענה",
            phoneActive: "בשיחה…",
            phoneEnded: "השיחה הסתיימה",
          };
          break;
        case "en":
          this.translationMissingWord = "Missing word on the picture";
          this.translation = {
            clickToResults: "Click for results",
            back: "Close",
            skipPoint: "Skip to the next point",
            skipPointBeware: "Attention! If you cannot find the sign or the answer, you can move to the next point, but it will cost you 10 points.",
            mistakes: "Points",
            runningTime: "Elapsed time",
            map: "Map",
            pointNumber: "On the map, find the nº",
            findMissingWord: "Go there and find the inscription shown in the image below.",
            didYouKnow: "Did you know?",
            goToQuestions: "Proceed",
            wellDone: "Well done",
            correctAnswer: "That is the correct answer!",
            continue: "Click to continue.",
            wrongAnswer: "That is not the correct answer.",
            tryAgain: "Click to try again.",
            visitOf: "We hope you enjoyed your visit of",
            yourResults: "Your results are:",
            errorNumber: "Number of points:",
            totalTime: "Total time:",
            goToRanking: "Before you leave, you can check out the results and see where you finished!",
            evolution: "Evolution",
            results: "Results",
            first: "",
            afterFirst: "",
            finishedTheGame: "You have finished the course, here is your result:",
            phoneIncoming: "Incoming call…",
            phoneAnswer: "Answer",
            phoneActive: "In call…",
            phoneEnded: "Call ended",
          };
          break;
        case "de":
          this.translationMissingWord = "Fehlendes Wort auf dem Bild";
          this.translation = {
            clickToResults: "Klicken für Ergebnisse",
            back: "Schließen",
            skipPoint: "Zum nächsten Punkt springen",
            skipPointBeware: "Achtung! Wenn Sie das Schild oder die Antwort nicht finden können, können Sie zum nächsten Punkt gehen, es kostet Sie jedoch 10 Punkte.",
            mistakes: "Punkte",
            runningTime: "Verstrichene Zeit",
            map: "Karte",
            pointNumber: "Auf der Karte, finde die Nr.",
            findMissingWord: "Gehe dorthin und finde die auf dem Bild unten gezeigte Inschrift.",
            didYouKnow: "Wussten Sie schon?",
            goToQuestions: "Fortfahren",
            wellDone: "Gut gemacht",
            correctAnswer: "Das ist die richtige Antwort!",
            continue: "Klicken, um fortzufahren.",
            wrongAnswer: "Das ist nicht die richtige Antwort.",
            tryAgain: "Klicken, um es erneut zu versuchen.",
            visitOf: "Wir hoffen, Sie haben Ihren Besuch genossen",
            yourResults: "Ihre Ergebnisse sind:",
            errorNumber: "Anzahl der Punkte:",
            totalTime: "Gesamtzeit:",
            goToRanking: "Bevor Sie gehen, können Sie sich die Ergebnisse ansehen und sehen, wo Sie gelandet sind!",
            evolution: "Entwicklung",
            results: "Ergebnisse",
            first: "",
            afterFirst: "",
            finishedTheGame: "Sie haben den Kurs beendet, hier ist Ihr Ergebnis:",
            phoneIncoming: "Eingehender Anruf…",
            phoneAnswer: "Antworten",
            phoneActive: "Im Gespräch…",
            phoneEnded: "Anruf beendet",
          };
          break;
        case "ar":
          this.translationMissingWord = "كلمة مفقودة في الصورة";
          this.translation = {
            clickToResults: "انقر للنتائج",
            back: "إغلاق",
            skipPoint: "تخطى إلى النقطة التالية",
            skipPointBeware: "انتبه! إذا لم تجد اللافتة أو الإجابة، يمكنك الانتقال إلى النقطة التالية، لكن ذلك سيكلفك 10 نقاط.",
            mistakes: "نقاط",
            runningTime: "الوقت المنقضي",
            map: "خريطة",
            pointNumber: "على الخريطة، ابحث عن الرقم",
            findMissingWord: "توجه إلى المكان وابحث عن النص الموجود في الصورة أدناه.",
            didYouKnow: "هل تعلم؟",
            goToQuestions: "متابعة",
            wellDone: "أحسنت",
            correctAnswer: "إجابة صحيحة!",
            continue: "انقر للمتابعة.",
            wrongAnswer: "هذه ليست الإجابة الصحيحة.",
            tryAgain: "انقر للمحاولة مجدداً.",
            visitOf: "نأمل أن تكون قد استمتعت بزيارة",
            yourResults: "نتائجك:",
            errorNumber: "عدد النقاط:",
            totalTime: "الوقت الإجمالي:",
            goToRanking: "قبل المغادرة، يمكنك الاطلاع على الترتيب ومعرفة مكانك!",
            evolution: "التقدم",
            results: "النتائج",
            first: "",
            afterFirst: "",
            finishedTheGame: "لقد أنهيت المسار، وهذه نتيجتك:",
            phoneIncoming: "مكالمة واردة…",
            phoneAnswer: "رد",
            phoneActive: "في مكالمة…",
            phoneEnded: "انتهت المكالمة",
          };
          break;
      }
    },

    requestBuzzer() {
      if (this.$refs.navScreen && typeof this.$refs.navScreen.flipToBuzzer === 'function') {
        this.$refs.navScreen.flipToBuzzer();
      }
    },

    slideMapInn() {
      document.getElementById("map").className = "showMap";
      this.mapVisible = true;
    },

    removeMap() {
      document.getElementById("map").classList.remove("showMap");
      this.mapVisible = false;
    },

    showResults() {
      this.$router.push("/resultsByPoints");
    },

    nextPointNumber() {
      if (!this.currentPointData) return;

      const pad = (num, size) => ("000" + num).slice(size * -1);

      if (this.pointNum >= this.pointsArrayOrder.length - 1) {
        this.showLastDialog = true;
        this.endTime = Date.now();
        this.gameTimeInSecond = Math.floor((this.endTime - this.startTime) / 1000);
        const time = this.gameTimeInSecond;
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = Math.floor(time % 60);
        this.gameSecondToTime = pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
        this.$store.dispatch("checkResults", {
          errorNumber: this.errorNumber,
          gameSecondToTime: this.gameSecondToTime,
          gameTimeInSecond: this.gameTimeInSecond,
        });
      } else {
        this.pointNum++;
        this.pointNumForEvolution++;
        localStorage.setItem("pointNumber", this.pointNum);
        localStorage.setItem("pointNumForEvolution", this.pointNumForEvolution);
        localStorage.setItem("withVideo", this.currentPointData?.withVideo || false);
        this.checkElementPicked();
        this.saveToLocalStorage();
        this.$store.dispatch("addEvolutionToDB", {
          pointNumber: this.pointNum,
          userKey: this.userKey,
          navigationName: this.gameParameters.navigationName,
        });
      }
    },

    afterNavigationComplete() {
      this.countdownTimer = '';
      if (this.currentPointHasInfo) {
        this.showInfoScreen();
        this.showButtonInfoScreen = true;
      } else if (this.currentPointHasExercise) {
        this.showPickedItemDiv();
      } else {
        this.nextPointNumber();
        this.showNavigation();
      }
    },

    afterInfoComplete() {
      if (this.currentPointHasExercise) {
        this.showPickedItemDiv();
      } else {
        this.nextPointNumber();
        this.showNavigation();
      }
    },

    checkElementPicked() {
      this.showPuzzle = false;
      this.showQuestions = false;
      this.showMultipleMatch = false;
      this.showPhotoComponent = false;
      this.showMemory = false;
      this.showJusteFaux = false;
      this.showMotManquant = false;
      this.showRushHour = false;
      this.showSignCard = false;

      if (this.isHistoireMode) {
        const item = this.currentStoryItem;
        if (!item) return;
        this.currentPoint = JSON.parse(JSON.stringify(item));
        const type = (item.picked || '').toString().trim().toLowerCase();
        if (type === 'puzzle') { this.showPuzzle = true; return; }
        if (type === 'multiplematch') { this.showMultipleMatch = true; return; }
        if (type === 'memory') { this.showMemory = true; return; }
        if (type === 'justefaux') { this.showJusteFaux = true; return; }
        if (type === 'motmanquant') { this.showMotManquant = true; return; }
        if (type === 'rushhour') { this.showRushHour = true; return; }
        if (type === 'signcard') { this.showSignCard = true; return; }
        if (type === 'photocomponent') { this.showPhotoComponent = true; return; }
        // Pour "questions" et défaut : les questions sont dans le store,
        // liées à item.pointNumber comme en mode géographique
        this.showQuestions = true;
        return;
      }

      const pointData = this.currentPointData;
      if (!pointData) {
        console.error("❌ No point data for index", this.pointNum);
        return;
      }
      this.currentPoint = JSON.parse(JSON.stringify(pointData));
      const typeAction = pointData.picked
        ? pointData.picked.toString().trim().toLowerCase()
        : "";
      switch (typeAction) {
        case "puzzle": this.showPuzzle = true; break;
        case "multiplematch": this.showMultipleMatch = true; break;
        case "memory": this.showMemory = true; break;
        case "justefaux": this.showJusteFaux = true; break;
        case "motmanquant": this.showMotManquant = true; break;
        case "rushhour": this.showRushHour = true; break;
        case "signcard": this.showSignCard = true; break;
        case "photocomponent": this.showPhotoComponent = true; break;
        case "questions": this.showQuestions = true; break;
        default: this.showQuestions = true; break;
      }
    },

    // ─── Tutorial helpers ──────────────────────────────────────
    getTutorialTarget(step) {
      // Step 0: point number / instruction area in the nav screen (top of page)
      if (step === 0) {
        const navEl = this.$refs.navScreen?.$el;
        return (navEl && navEl.querySelector('.il-point-circle, .mw-point-circle, #sentenceAboveMap')) || this.$refs.tutPointNum;
      }
      if (step === 1) return this.$refs.tutMapBtn;
      if (step === 2) return document.querySelector('.removeMapButton');
      if (step === 3) return document.querySelector('.currentPosButton');
      if (step === 4) {
        if (this.navigationScreen === 'MissingWord') return this.$refs.navScreen?.$el?.querySelector('.mw-clue-image');
        if (this.navigationScreen === 'DynamicMap') return this.$refs.navScreen?.$el?.querySelector('#map2');
        return this.$refs.navScreen?.$el?.querySelector('.il-images-list');
      }
      if (step === 5) return this.$refs.navScreen?.$el?.querySelector('.mw-input');
      if (step === 6) return this.$refs.navScreen?.$el?.querySelector('.mw-skip-btn');
      return null;
    },

    updateTutorialSpot() {
      const el = this.getTutorialTarget(this.tutorialStep);
      if (!el) { this.tutSpot = null; return; }
      const r = el.getBoundingClientRect();
      this.tutSpot = { x: r.left, y: r.top, w: r.width, h: r.height };
    },

    tutorialNext() {
      const isMW = this.navigationScreen === 'MissingWord';
      const maxStep = isMW ? 6 : 3;

      // Step 1 → 2: open the map first
      if (this.tutorialStep === 1) {
        if (!this.mapVisible) this.slideMapInn();
        this.tutorialStep = 2;
        this.$nextTick(() => this.updateTutorialSpot());
        return;
      }

      // Step 3 → close map then go to step 4 (images or missingWord clue)
      if (this.tutorialStep === 3) {
        if (this.mapVisible) this.removeMap();
        this.tutorialStep = 4;
        this.$nextTick(() => this.updateTutorialSpot());
        return;
      }

      if (this.tutorialStep >= maxStep) {
        this.endTutorial();
        return;
      }

      this.tutorialStep++;
      this.$nextTick(() => this.updateTutorialSpot());
    },

    maybeStartScreenTutorial() {
      if (this.tutorialActive) return;
      if (!this.showMainScreen) return;
      if (localStorage.getItem('tutorialScreensWanted') !== 'true') return;
      const screen = this.navigationScreen;
      const sawImagesList = !!localStorage.getItem('tutorialSeenImagesList');
      const sawMissingWord = !!localStorage.getItem('tutorialSeenMissingWord');
      const sawDynamicMap = !!localStorage.getItem('tutorialSeenDynamicMap');
      const sawGenericSteps = sawImagesList || sawMissingWord || sawDynamicMap;
      if (screen === 'ImagesList' && !sawImagesList) {
        this.tutorialActive = true;
        this.tutorialStep = sawGenericSteps ? 4 : 0;
        this.$nextTick(() => this.updateTutorialSpot());
      } else if (screen === 'MissingWord' && !sawMissingWord) {
        this.tutorialActive = true;
        this.tutorialStep = sawGenericSteps ? 4 : 0;
        this.$nextTick(() => this.updateTutorialSpot());
      } else if (screen === 'DynamicMap' && !sawDynamicMap) {
        this.tutorialActive = true;
        this.tutorialStep = sawGenericSteps ? 4 : 0;
        this.$nextTick(() => this.updateTutorialSpot());
      }
    },

    endTutorial() {
      const screen = this.navigationScreen;
      if (screen === 'ImagesList') localStorage.setItem('tutorialSeenImagesList', '1');
      if (screen === 'MissingWord') localStorage.setItem('tutorialSeenMissingWord', '1');
      if (screen === 'DynamicMap') localStorage.setItem('tutorialSeenDynamicMap', '1');
      this.tutorialActive = false;
      this.tutorialStep = -1;
      this.tutSpot = null;
      localStorage.removeItem('inGameTutorial');
    },
  },

  beforeDestroy() {
    localStorage.removeItem('inGameTutorial');
    const nav = document.querySelector('nav.navbar');
    const bar = this.$el?.querySelector('.bottomBar');
    if (nav) nav.style.visibility = '';
    if (bar) bar.style.visibility = '';
  },
};
</script>

<style scoped>
.youtube-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100%;
  border: none;
}

.youtube-iframe * {
  width: 100% !important;
}

/* ===== END GAME SCREEN ===== */
.endScreen {
  position: fixed;
  top: 0; left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  z-index: 100;
  background: linear-gradient(160deg, #0d1b4b 0%, #1a3a8f 45%, #6b21a8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.endCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px 24px;
  width: 90%;
  max-width: 360px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 28px;
  backdrop-filter: blur(12px);
  text-align: center;
  color: white;
  position: relative;
  z-index: 2;
}

.endTrophy {
  font-size: 72px;
  animation: trophyBounce 0.8s ease-out;
  filter: drop-shadow(0 0 20px rgba(255, 215, 0, 0.6));
}

@keyframes trophyBounce {
  0%   { transform: scale(0) rotate(-15deg); opacity: 0; }
  60%  { transform: scale(1.2) rotate(5deg); opacity: 1; }
  80%  { transform: scale(0.95) rotate(-2deg); }
  100% { transform: scale(1) rotate(0deg); }
}

.endName {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: 0.5px;
}

.endScoreLabel {
  font-size: 14px;
  opacity: 0.75;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.endScoreCircle {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  box-shadow: 0 0 30px rgba(245, 158, 11, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: scorePop 0.5s ease-out 0.3s both;
}

@keyframes scorePop {
  0%   { transform: scale(0); opacity: 0; }
  70%  { transform: scale(1.1); }
  100% { transform: scale(1); opacity: 1; }
}

.endScoreNumber {
  font-size: 48px;
  font-weight: 900;
  color: white;
  line-height: 1;
}

.endScoreUnit {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255,255,255,0.85);
}

.endTime {
  font-size: 18px;
  opacity: 0.8;
  font-weight: 600;
}

.endResultsBtn {
  margin-top: 8px;
  padding: 14px 32px;
  background: white;
  color: #1a3a8f;
  border: none;
  border-radius: 50px;
  font-size: 17px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0,0,0,0.25);
  transition: transform 0.15s, box-shadow 0.15s;
  width: 100%;
  direction: rtl;
}

.endResultsBtn:active {
  transform: scale(0.97);
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
}

.evolutionBottomDiv {
  position: relative;
  bottom: 36px;
  background: white;
  height: 80px;
  width: 80px;
  border-radius: 100%;
  color: #3369bc;
  font-size: 50px;
  border: 1px solid #3369bc;
  z-index: 15;
  display: flex;
  align-items: center;
  justify-content: center;
}

.countdown-in-circle {
  font-size: 22px;
  font-weight: 900;
  color: #0090e3;
  font-family: VarelaRound, sans-serif;
  letter-spacing: 1px;
}

.point-num-text {
  font-size: 32px;
  font-weight: 900;
  color: #3369bc;
  font-family: VarelaRound, sans-serif;
}

.smiley-circle-img {
  object-fit: contain;
}


.bottomBar {
  height: 80px;
  width: 100vw;
  max-width: 590px;
  left: 50% !important;
  transform: translateX(-50%);
  margin: 0 !important;
  z-index: 10100;
  background: #0070b0;
  color: white;
}

.redColor {
  color: red;
}

.starMoveUp {
  animation: moveUp 2s ease-in-out;
  bottom: 80px;
  opacity: 1;
}

@keyframes moveUp {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  90% {
    opacity: 1;
  }

  100% {
    transform: translateY(-100px);
    opacity: 0;
  }
}

.removeMapButton {
  position: fixed;
  bottom: 88px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10200;
  padding: 14px 36px;
  border-radius: 24px;
  background: rgba(220, 38, 38, 0.9);
  backdrop-filter: blur(8px);
  border: none;
  color: white;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.5);
  transition: background 0.15s;
  white-space: nowrap;
}

.removeMapButton:hover {
  background: rgba(185, 28, 28, 0.95);
}

.btn3d {
  position: relative;
  top: -6px;
  border: 0;
  transition: all 40ms linear;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
}

.btn3d:active:focus,
.btn3d:focus:hover,
.btn3d:focus {
  -moz-outline-style: none;
  outline-style: none;
  outline: medium none;
}

.btn3d:active,
.btn3d.active {
  top: 2px;
}

.btn3d.btn-primary {
  box-shadow: 0 0 0 1px #354093 inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
    0 8px 0 0 #354093, 0 8px 8px 1px rgb(0 0 0 / 50%);
  background-color: rgb(63, 149, 131);
}

.btn3d.btn-primary:active,
.btn3d.btn-primary.active {
  box-shadow: 0 0 0 1px #354093 inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 1px 3px 1px rgba(0, 0, 0, 0.3);
  background-color: rgb(63, 149, 131);
}

.mainButton {
  border-radius: 50px;
  color: white !important;
  display: block;
  margin: 0px auto;
  height: 90px !important;
  width: 90px;
  border: solid darkgreen 2px;
}

.gps-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(6px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gps-modal {
  background: white;
  border-radius: 20px;
  padding: 28px 24px;
  max-width: 360px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.4);
  text-align: center;
}
.gps-modal-icon { font-size: 48px; margin-bottom: 10px; }
.gps-modal-title { font-size: 18px; font-weight: 800; color: #1a2e4a; margin-bottom: 10px; }
.gps-modal-text { font-size: 14px; color: #444; line-height: 1.5; margin-bottom: 16px; }
.gps-modal-steps { display: flex; flex-direction: column; gap: 10px; margin-bottom: 20px; text-align: left; }
.gps-modal-step { display: flex; align-items: flex-start; gap: 10px; font-size: 13px; color: #333; line-height: 1.4; }
.gps-step-num { min-width: 24px; height: 24px; border-radius: 50%; background: #1a73e8; color: white; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.gps-modal-actions { display: flex; flex-direction: column; gap: 10px; }
.gps-modal-btn { border: none; border-radius: 50px; padding: 13px 20px; font-size: 15px; font-weight: 700; cursor: pointer; width: 100%; }
.gps-btn-ok { background: linear-gradient(135deg, #1a73e8, #0d47a1); color: white; }
.gps-btn-close { background: #f1f5f9; color: #555; }

.currentPosButton {
  position: absolute;
  top: 61px;
  font-size: 19px;
  z-index: 100;
  color: #0070b0;
  left: 11px;
  background: white;
  border: 3px solid #0070b0;
  padding: 6px 8px 6px;
  border-radius: 5px;
}

#erreurs {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 28px);
}

#evolution {
  font-size: 12px;
  position: absolute;
  top: 27px;
  left: calc(50% - 29px);
}

#carte { font-size: inherit; }

.center {
  display: block;
  margin: 0px auto;
}

#mapButton {
  width: 30px;
  position: absolute;
  top: 4px;
  right: -10px;
  margin-right: calc(50vw - 155px);
  font-size: 25px;
  color: white;
  width: 42px;
  height: 40px;
  padding: 5px;
  z-index: 5;
}

#map {
  position: fixed;
  top: -100vh;
  right: 0;
  height: calc(100vh - 80px);
  width: 100vw;
  z-index: 100;
  overflow: hidden;
  transition: all 1s;
}

.showMap {
  position: fixed;
  top: 0 !important;
  right: 0;
  height: calc(100vh - 80px);
  width: 100vw;
  z-index: 100;
  overflow: hidden !important;
  transition: all 1s;
}

#imgUrl {
  display: block;
  margin: 0 auto;
}

.errorsTimeMap {
  border: none;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}

.errorsTimeMap>svg {
  position: relative;
  bottom: 3px;
}

.pointNumber {
  margin: 0 auto;
  border: #3369bc solid 3px !important;
  border-radius: 100px;
  height: 55px;
  width: 55px;
  font-size: 36px;
  padding-right: 1px;
  padding-top: 3px;
  font-weight: bold;
  color: white;
}

.rtl {
  direction: rtl;
}

.myModal {
  height: auto;
  min-height: 200px;
  min-width: 300px;
  width: auto;
  border-radius: 10px;
  max-width: 100vw;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: white;
}

.modalInformationPoint {
  box-shadow: none;
  width: 100vw;
  height: auto;
  overflow: auto;
  font-weight: 100;
  color: white;
  direction: rtl;
  white-space: pre-line;
  font-size: 20px;
  text-align: start;
}

.red {
  background-color: #d41a1b;
  border: solid white 10px;
}

.over {
  position: fixed;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3;
}

.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}

.continueButton {
  width: 80%;
  display: block;
  margin: 0px auto;
  border-radius: 50px;
}

.question {
  text-align: center;
  font-family: "Assistant", sans-serif;
  font-weight: 400;
  font-size: 22px;
  color: black;
}

.userName {
  font-size: 18px;
  text-align: left;
  color: black;
}

.time {
  letter-spacing: 0.05em;
  font-size: 24px;
  font-family: "Cabin", sans-serif;
  text-align: center;
}

.startTime {
  letter-spacing: 0.05em;
  font-size: 40px;
  padding: 5px 0;
  font-family: "Inconsolata", monospace;
  color: #ffffff;
  text-align: center;
  position: relative;
  left: 50%;
  margin-top: 50px;
  top: -24px;
  transform: translate(-50%, -50%);
  color: #daf6ff;
}

.fadeIn {
  -webkit-animation: fadein 1s;
  -moz-animation: fadein 1s;
  -ms-animation: fadein 1s;
  -o-animation: fadein 1s;
  animation: fadein 1s;
}

.confetti {
  width: 15px;
  height: 15px;
  background-color: #b1f70f;
  position: absolute;
  top: 0px;
  left: 50%;
  animation: confetti 5s ease-in-out -2s infinite;
  transform-origin: left top;
  z-index: 5;
}

.confetti:nth-child(1) {
  background-color: #faf623;
  left: 10%;
  animation-delay: 0;
}

.confetti:nth-child(2) {
  background-color: #129dee;
  left: 20%;
  animation-delay: -5s;
}

.confetti:nth-child(3) {
  background-color: #e21f0d;
  left: 30%;
  animation-delay: -3s;
}

.confetti:nth-child(4) {
  background-color: #f1dc6f;
  left: 40%;
  animation-delay: -2.5s;
}

.confetti:nth-child(5) {
  background-color: #039cf5;
  left: 50%;
  animation-delay: -4s;
}

.confetti:nth-child(6) {
  background-color: #f52916;
  left: 60%;
  animation-delay: -6s;
}

.confetti:nth-child(7) {
  background-color: #5cf24e;
  left: 70%;
  animation-delay: -1.5s;
}

.confetti:nth-child(8) {
  background-color: #d717e9;
  left: 80%;
  animation-delay: -2s;
}

.confetti:nth-child(9) {
  background-color: #f30e34;
  left: 90%;
  animation-delay: -3.5s;
}

.confetti:nth-child(10) {
  background-color: #7cf24e;
  left: 100%;
  animation-delay: -2.5s;
}

.confetti:nth-child(11) {
  background-color: #f52916;
  left: 15%;
  animation-delay: -6.5s;
}

.confetti:nth-child(12) {
  background-color: #5cf24e;
  left: 25%;
  animation-delay: -1.8s;
}

.confetti:nth-child(13) {
  background-color: #d717e9;
  left: 75%;
  animation-delay: -2.5s;
}

.confetti:nth-child(14) {
  background-color: #f30e34;
  left: 85%;
  animation-delay: -3.8s;
}

.confetti:nth-child(15) {
  background-color: #7cf24e;
  left: 55%;
  animation-delay: -4.2s;
}

.confetti:nth-child(16) {
  background-color: #d717e9;
  left: 75%;
  animation-delay: -3.5s;
}

.confetti:nth-child(17) {
  background-color: #7cf24e;
  left: 55%;
  animation-delay: -4.9s;
}

.confetti:nth-child(18) {
  background-color: #f30e34;
  left: 85%;
  animation-delay: -6.8s;
}

@keyframes confetti {
  0% {
    transform: rotateZ(15deg) rotateY(0deg) translate(0, 0);
  }

  25% {
    transform: rotateZ(5deg) rotateY(360deg) translate(-5vw, 20vh);
  }

  50% {
    transform: rotateZ(15deg) rotateY(720deg) translate(7vw, 60vh);
  }

  75% {
    transform: rotateZ(5deg) rotateY(1080deg) translate(-25vw, 80vh);
  }

  100% {
    transform: rotateZ(15deg) rotateY(1440deg) translate(20vw, 110vh);
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-ms-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-o-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@font-face {
  font-family: noot;
  src: url(../../static/fonts/Noot/noot-aj.woff);
}

/* ===== INFORMATION SCREEN ===== */
.info-screen {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9500;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.info-screen--fullvideo {
  z-index: 10200;
  background: rgba(0, 10, 40, 0.97);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 0 0;
  overflow: hidden;
}

/* Layout VERTICAL: Shorts fullscreen */
.info-vertical-video {
  position: fixed;
  inset: 0;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10300;
}

.vertical-iframe {
  width: min(56.25vh, 100vw);
  height: min(100vh, 177.78vw);
  border: none;
}

/* Layout A: scrollable content area */
.info-scroll-area {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Layout A: video full-width */
.info-video-full {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: black;
  flex-shrink: 0;
}

.info-below-video {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  color: white;
  font-family: VarelaRound, sans-serif;
}

.info-btn-bar {
  flex-shrink: 0;
  padding: 8px 16px 100px;
  display: flex;
  justify-content: center;
}

.ar-top-btn-bar {
  position: fixed;
  top: 75px;
  left: 16px;
  z-index: 1000;
  display: flex;
  gap: 10px;
}

.ar-top-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.6);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ar-top-btn--continue {
  width: auto;
  border-radius: 24px;
  padding: 0 14px;
  gap: 6px;
}

.ar-top-btn-label {
  font-size: 15px;
  font-weight: 700;
  font-family: VarelaRound, sans-serif;
  white-space: nowrap;
}

/* Vertical video: loading spinner before continue button */
.vv-loading-spinner {
  width: 44px;
  height: 44px;
  animation: vv-spin 1s linear infinite;
}
@keyframes vv-spin {
  to { transform: rotate(360deg); }
}

.vv-btn-fade-enter-active { transition: opacity 0.5s ease; }
.vv-btn-fade-leave-active { transition: opacity 0.2s ease; }
.vv-btn-fade-enter, .vv-btn-fade-leave-to { opacity: 0; }

/* ===== PHONE CALL SCREEN ===== */
.phone-screen {
  position: fixed;
  inset: 0;
  z-index: 10400;
  background: linear-gradient(160deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* --- Incoming call --- */
.phone-incoming {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 60px 24px 56px;
}

.phone-header-time {
  font-size: 52px;
  font-weight: 200;
  letter-spacing: 2px;
  opacity: 0.9;
}

.phone-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.phone-ripple-container {
  position: relative;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-ripple {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  animation: phone-ripple-anim 2.4s ease-out infinite;
}
.phone-ripple.r1 { width: 130px; height: 130px; animation-delay: 0s; }
.phone-ripple.r2 { width: 130px; height: 130px; animation-delay: 0.8s; }
.phone-ripple.r3 { width: 130px; height: 130px; animation-delay: 1.6s; }

@keyframes phone-ripple-anim {
  0%   { transform: scale(0.85); opacity: 0.7; }
  100% { transform: scale(2.0);  opacity: 0; }
}

.phone-avatar-circle {
  position: relative;
  z-index: 2;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  border: 2px solid rgba(255,255,255,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-caller-name {
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-align: center;
}

.phone-status-label {
  font-size: 15px;
  opacity: 0.65;
  letter-spacing: 0.5px;
}

.phone-action-bar {
  display: flex;
  justify-content: center;
}

.phone-answer-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.phone-answer-btn {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: none;
  background: #34c759;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(52, 199, 89, 0.5);
  animation: phone-btn-pulse 1.8s ease-in-out infinite;
}

@keyframes phone-btn-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(52, 199, 89, 0.5); }
  50%       { box-shadow: 0 0 0 16px rgba(52, 199, 89, 0); }
}

.phone-answer-label {
  font-size: 13px;
  opacity: 0.7;
}

/* --- Active call --- */
.phone-active {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 80px 24px 64px;
}

.phone-active-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.phone-active-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255,255,255,0.12);
  border: 2px solid rgba(255,255,255,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-active-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  opacity: 0.7;
}

.phone-active-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34c759;
  animation: phone-dot-blink 1.2s ease-in-out infinite;
}

@keyframes phone-dot-blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.2; }
}

.phone-continue-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}

.phone-continue-btn {
  background: linear-gradient(135deg, #34c759, #28a745);
  color: white;
  border: none;
  border-radius: 32px;
  padding: 16px 40px;
  font-size: 18px;
  font-weight: 700;
  font-family: VarelaRound, sans-serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 20px rgba(52, 199, 89, 0.4);
}

.phone-continue-fade-enter-active { transition: all 0.5s ease; }
.phone-continue-fade-leave-active { transition: all 0.3s ease; }
.phone-continue-fade-enter        { opacity: 0; transform: translateY(30px); }
.phone-continue-fade-leave-to     { opacity: 0; transform: translateY(30px); }

/* Layout B: no video — scrollable card, button always visible */
.info-card {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: 12px auto 0;
  width: 92%;
  max-width: 540px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  padding: 28px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  color: white;
  font-family: VarelaRound, sans-serif;
}

.info-header-icon {
  font-size: 48px;
  filter: drop-shadow(0 0 12px rgba(255, 220, 100, 0.5));
}

.info-audio-wrap {
  width: 100%;
}

.info-audio {
  width: 100%;
  border-radius: 50px;
}

.info-text {
  width: 100%;
  font-size: 18px;
  line-height: 1.7;
  white-space: pre-line;
  text-align: start;
  direction: rtl;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 18px 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.info-continue-btn {
  padding: 16px 48px;
  background: #0090e3;
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 20px;
  font-weight: 700;
  font-family: VarelaRound, sans-serif;
  cursor: pointer;
  box-shadow: 0 4px 0 #0065a3, 0 6px 12px rgba(0, 0, 0, 0.3);
  transition: transform 0.1s, box-shadow 0.1s;
  width: 80%;
  margin-top: 8px;
  direction: rtl;
}

.info-continue-btn:active {
  transform: translateY(4px);
  box-shadow: 0 0 0 #0065a3, 0 2px 6px rgba(0, 0, 0, 0.3);
}

.info-btn-waiting {
  background: rgba(0, 144, 227, 0.35);
  box-shadow: none;
  cursor: default;
}

/* ===== GPS PERMISSION PROMPT ===== */
.gps-prompt-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.75);
  z-index: 500;
  padding: 24px;
}

.gps-prompt-card {
  background: #1c1c1e;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 32px 24px;
  max-width: 340px;
  width: 100%;
  text-align: center;
  color: #fff;
}

.gps-prompt-icon {
  font-size: 52px;
  margin-bottom: 14px;
}

.gps-prompt-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 12px;
}

.gps-prompt-text {
  font-size: 15px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 10px;
}

.gps-prompt-sub {
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 22px;
}

.gps-checking {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  padding: 12px 0;
}

.gps-prompt-btn-primary {
  width: 100%;
  padding: 14px;
  border-radius: 14px;
  border: none;
  background: #0a84ff;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 10px;
}

.gps-prompt-btn-secondary {
  width: 100%;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  cursor: pointer;
}

.gps-denied-banner {
  position: fixed;
  top: 62px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 13px;
  padding: 8px 20px;
  border-radius: 20px;
  z-index: 500;
  white-space: nowrap;
  pointer-events: none;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.4s; }
.fade-enter-from, .fade-leave-to       { opacity: 0; }

/* ===== IN-GAME TUTORIAL ===== */
/* z-indexes must be above bottomBar (10100) */
.tut-dark-bg {
  position: fixed;
  inset: 0;
  background: transparent;
  z-index: 10200;
}

.tut-spotlight {
  position: fixed;
  border-radius: 14px;
  background: transparent;
  box-shadow: 0 0 0 9999px rgba(0,0,0,0.62), 0 0 0 3px rgba(255,255,255,0.7);
  z-index: 10201;
  pointer-events: none;
  animation: tut-glow 2s ease-in-out infinite;
}

@keyframes tut-glow {
  0%, 100% { box-shadow: 0 0 0 9999px rgba(0,0,0,0.62), 0 0 0 3px rgba(255,255,255,0.7); }
  50%       { box-shadow: 0 0 0 9999px rgba(0,0,0,0.62), 0 0 0 5px rgba(255,255,255,1), 0 0 18px rgba(255,255,255,0.35); }
}

.tut-bubble {
  position: fixed;
  background: white;
  border-radius: 18px;
  padding: 18px 20px 14px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.28);
  z-index: 10202;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: VarelaRound, system-ui, sans-serif;
}

.tut-bubble-step {
  font-size: 11px;
  color: #aaa;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.tut-bubble-text {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.55;
}

.tut-bubble-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
}

.tut-btn-skip {
  background: none;
  border: none;
  color: #bbb;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 0;
  font-family: VarelaRound, system-ui, sans-serif;
}

.tut-btn-next {
  background: #1a73e8;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 9px 22px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  font-family: VarelaRound, system-ui, sans-serif;
}

.tut-btn-next:active { background: #1558b0; transform: scale(0.97); }


/* brightness slider — vertical video (fixed top-right, opposite the continue button) */
.vb-slider-wrap {
  position: fixed;
  top: 75px;
  right: 16px;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  border-radius: 20px;
  padding: 6px 12px;
}
/* brightness slider — normal video (absolute overlay top-left) */
.vb-overlay {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  border-radius: 20px;
  padding: 4px 10px;
}
.vb-icon { font-size: 16px; flex-shrink: 0; }
.vb-slider { width: 90px; accent-color: #facc15; cursor: pointer; }
</style>
